import { compressorTypes, DeviceType } from '@/constants/deviceTypeEnum';
import { useTranslation } from 'react-i18next';

export const useLabelValueServiceInformationItemsByDeviceType = entity => {
  const { t } = useTranslation();
  const {
    runHours,
    loadHours,
    nextServiceHours,
    nextServiceName,
    deviceType,
    dryerFilterServiceHours,
    dryerDesiccantServiceHours,
    dryerValveServiceHours,
  } = entity;

  const labelValueServiceInformationItems = [];

  if (compressorTypes.includes(deviceType as DeviceType)) {
    labelValueServiceInformationItems.push(
      {
        label: t('workingHours'),
        prefix: t('run'),
        value: runHours,
        unit: t('h'),
      },
      {
        prefix: t('load'),
        value: loadHours,
        unit: t('h'),
      },
      {
        label: t('hoursToService'),
        value: nextServiceHours,
        unit: t('h'),
      },
      {
        label: t('serviceType'),
        value: nextServiceName,
      },
    );
  } else if (deviceType === DeviceType.Booster) {
    labelValueServiceInformationItems.push(
      {
        label: t('workingHours'),
        prefix: t('run'),
        value: runHours,
        unit: t('h'),
      },
      {
        prefix: t('load'),
        value: loadHours,
        unit: t('h'),
      },
    );
  } else if (deviceType === DeviceType.DesiccantAirDryer) {
    labelValueServiceInformationItems.push(
      {
        label: t('filter'),
        value: dryerFilterServiceHours,
        unit: t('h'),
      },
      {
        label: t('desiccant'),
        value: dryerDesiccantServiceHours,
        unit: t('h'),
      },
      {
        label: t('Valve'),
        value: dryerValveServiceHours,
        unit: t('h'),
      },
    );
  }

  return labelValueServiceInformationItems;
};
